module.exports = __webpack_public_path__ + "static/media/category.5e45c0bf.xlsx";